/* -------------------------------------------------------------------------------------
Main module creating the Vue app.

Main components
---------------
created:
- check if user data is stored in local storage
- If yes, the user data is committed to the vuex store
- and user initial data load from the API is triggered

methods:
- 
---------------------------------------------------------------------------------------*/
require('dotenv').config() // include .env file

// import base modules
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './vuex/store'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

new Vue({
  router,
  store,

  created() {
    // get user data from localStorage (user was logged in before if available)
    const userString = localStorage.getItem('user')
    if (userString) {
      const userData = JSON.parse(userString)
      this.$store.dispatch('user/setUserData', userData)
      this.$store.dispatch('user/getUserSpecificData')
      this.$store.dispatch('user/getUnspecificData')
    }
    // ACTION: reactivate this function
    // close back hole when user tries to add dummy token into local storage (not working correctly)
    /*axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          this.$store.dispatch('logout')
        }
        return Promise.reject(error)
      }
    )*/
  },

  vuetify,
  render: h => h(App)
}).$mount('#app')
